export default __webpack_public_path__ + "media/Pages/pickups/assets/profile-2ed1d47e35cc9fd88bbe791deb8145bf.svg";